module.exports = "/_next/static/files/d3551f67809df63c652faebaa18a9ed6.jpg";